<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  @if (isRmbRmc) {
  <p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
  }
  <h1 class="person-label">{{ selectedIndividual | fullname }}</h1>
  <section [formGroup]="getControl('data')">
    <nh-field
      id="td_taxDeductions"
      label="{{ 'DOES_2' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'TAX_DEDUCTIONS_STATIC_TEXT1' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ml-2 ps-1"
        [content]="popTaxDeductions | globalTranslate"
      ></nh-popover>
      <select
        nhTranslate
        name="taxDeductions"
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          (selectedIndividual | fullname) +
          (' ' + ('TAX_DEDUCTIONS_STATIC_TEXT1' | globalTranslate))
        "
        [attr.aria-required]="true"
        formControlName="taxDeductions"
        [items]="tableCodeValue('YESNO', 'data.taxDeductions')"
      ></select>
    </nh-field>
    <div (window:resize)="onResize($event)"></div>

    @if (isY('data.taxDeductions')) {
    <section>
      <h2 class="section-header">
        <strong>{{ "TAX_DEDUCTIONS_STATIC_TEXT2" | globalTranslate }}</strong>
      </h2>
      <hr />
      <p>
        {{ "IF" | globalTranslate }} {{ selectedIndividual | fullname }}
        {{ "TAX_DEDUCTIONS_STATIC_TEXT3" | globalTranslate }}
      </p>
      <ng-container formArrayName="taxDeductionsIndvData">
        <div class="details-container mb-2">
          @if (isDesktop) {
          <div class="d-flex p-3 bg-details-container">
            <div class="col-md-3">
              {{ "TAX_DEDUCTIONS_STATIC_TEXT4" | globalTranslate }}
            </div>
            <div class="col-md-3">
              {{ "TAX_DEDUCTIONS_STATIC_TEXT5" | globalTranslate }}
            </div>
            <div class="col-md-3 ps-4">
              {{ "TAX_DEDUCTIONS_STATIC_TEXT6" | globalTranslate }}
            </div>
          </div>
          } @for (row of taxDeductionsIndvData.controls; track row; let i =
          $index) {
          <ng-container [formGroupName]="i">
            @if (getValue('iden', row) !== 'd') {
            <div class="row g-3 bg-even pl-3 m-0 pt-3 pr-3">
              <nh-field
                [attr.aria-required]="false"
                id="td_indvId"
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                label="{{ 'TAX_DEDUCTIONS_STATIC_TEXT4' | globalTranslate }}"
                class="col-md-3"
              >
                <select
                  nhTranslate
                  name="indvId"
                  [items]="members"
                  bindValue="identifier"
                  bindLabel="name.fullName"
                  formControlName="indvId"
                  [attr.aria-label]="
                    'TAX_DEDUCTIONS_STATIC_TEXT4' | globalTranslate
                  "
                  [attr.disabled]="true"
                ></select>
              </nh-field>
              <nh-field
                [attr.aria-required]="true"
                id="td_deductionType"
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="true"
                label="{{ 'TAX_DEDUCTIONS_STATIC_TEXT5' | globalTranslate }}"
                class="col-md-3"
              >
                <select
                  nhTranslate
                  name="deductionType"
                  [attr.aria-label]="
                    'TAX_DEDUCTIONS_STATIC_TEXT5' | globalTranslate
                  "
                  [items]="
                    tableCodeValue(
                      'MPDEDUCTIONS',
                      taxDeductionsIndvData.controls[i]
                    )
                  "
                  (change)="
                    onTaxTypeChange(
                      taxDeductionsIndvData.value[i].deductionType.code,
                      row
                    )
                  "
                  formControlName="deductionType"
                ></select>
              </nh-field>
              <nh-field
                [attr.aria-required]="true"
                id="td_deductionAmount"
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="true"
                label="{{ 'TAX_DEDUCTIONS_STATIC_TEXT6' | globalTranslate }}"
                class="col-md-3"
              >
                <nh-input-group prepend="$">
                  <input
                    nh
                    type="text"
                    placeholder="0.00"
                    mask="separator.2"
                    thousandSeparator=""
                    separatorLimit="999999999"
                    name="deductionAmount"
                    [attr.aria-label]="
                      'TAX_DEDUCTIONS_STATIC_TEXT6' | globalTranslate
                    "
                    formControlName="deductionAmount"
                    class="form-control"
                  />
                </nh-input-group>
              </nh-field>
              @if (taxDeductionsIndvData.controls.length >= 1) {
              <div class="col pt-1 hover-red">
                <button
                  class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                  (click)="removeTaxDeductionsRow(i)"
                >
                  <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
                  <nh-remove-svg></nh-remove-svg>
                </button>
              </div>
              }
              <div class="container">
                <div class="row">
                  <div class="col-md-3"></div>
                  @if
                  (taxTypeAlp(taxDeductionsIndvData?.value[i]?.deductionType?.code))
                  {
                  <div class="col-md-6">
                    <nh-field
                      [attr.aria-required]="true"
                      id="td_alimonyOrderDate"
                      [mandatory]="true"
                      label="{{
                        'TAX_DEDUCTIONS_STATIC_TEXT7' | globalTranslate
                      }}"
                    >
                      <nh-datepicker>
                        <input
                          type="text"
                          class="form-control"
                          name="alimonyOrderDate"
                          formControlName="alimonyOrderDate"
                          [attr.aria-label]="
                            'TAX_DEDUCTIONS_STATIC_TEXT7' | globalTranslate
                          "
                          placeholder="mm/dd/yyyy"
                          [minDate]="minimumDate"
                          [maxDate]="today"
                          bsDatepicker
                          nh
                        />
                      </nh-datepicker>
                    </nh-field>
                  </div>
                  } @if
                  (taxTypeOther(taxDeductionsIndvData?.value[i]?.deductionType?.code))
                  {
                  <div class="col-md-6">
                    <nh-field
                      [attr.aria-required]="true"
                      id="td_otherExpenseName"
                      [mandatory]="true"
                      label="{{
                        'TAX_DEDUCTIONS_STATIC_TEXT8' | globalTranslate
                      }}"
                    >
                      <input
                        type="text"
                        [attr.aria-label]="
                          'TAX_DEDUCTIONS_STATIC_TEXT8' | globalTranslate
                        "
                        formControlName="otherExpenseName"
                        class="form-control"
                        name="otherExpenseName"
                        maxlength="100"
                      />
                    </nh-field>
                  </div>
                  }
                  <div class="col-md-3"></div>
                </div>
              </div>
            </div>
            }
          </ng-container>
          }
        </div>
        <div class="pt-1 hover-red text-start">
          <button
            class="btn btn-link btn-lg hover-red"
            (click)="addTaxDeductionsRow()"
            [disabled]="!getControl('data.taxDeductionsIndvData').valid"
          >
            <span class="pe-2">{{ "ADD_1" | globalTranslate }}</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </ng-container>
    </section>
    }
  </section>
</nh-form>